import { render, staticRenderFns } from "./CardReview.vue?vue&type=template&id=6c8a1220&scoped=true&"
import script from "./CardReview.vue?vue&type=script&lang=ts&"
export * from "./CardReview.vue?vue&type=script&lang=ts&"
import style0 from "./CardReview.vue?vue&type=style&index=0&id=6c8a1220&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c8a1220",
  null
  
)

export default component.exports